import { Box, css, Text } from "@storyofams/react-ui";
import Image from "next/image";
import Link from "next/link";
import { BlogCard } from "~components/common/BlogCard";

export const Blog = ({ content, size }) => {
  if (content.blog)
    return (
      <>
        <Link
          href={
            content.component === "blog"
              ? `/blog/${content.blog?.slug}`
              : `/plant/${content.blog?.slug}`
          }
          passHref
        >
          <Box
            cursor={"pointer"}
            flexDirection={["column", size === 1 ? "row" : "column"]}
            p={["15px", size === 3 ? "15px" : "25px"]}
            border="1px solid grey200"
            borderRadius={"md"}
            flexWrap="nowrap"
            display={[content.isSmallCard ? "none" : "flex", "flex"]}
          >
            <Box
              mr={[0, size === 1 && "24px"]}
              width={["100%", size === 1 ? "257px" : "100%"]}
              flex="none"
              position="relative"
              height={[
                "216px",
                size === 3 ? "200px" : size === 1 ? "167px" : "300px",
              ]}
              css={css({
                img: {
                  borderRadius: "sm",
                },
              })}
            >
              {content?.blog?.content?.thumbnail && (
                <Image
                  src={content?.blog?.content?.thumbnail?.filename}
                  objectFit="cover"
                  layout="fill"
                />
              )}
            </Box>
            <Box>
              <Text
                mt="10px"
                maxWidth={["300px", size === 3 ? "218px" : "333px"]}
                fontSize={"16px"}
                fontWeight={700}
                lineHeight="20px"
                fontFamily={"DINPro"}
                css={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {content?.blog?.content?.title?.toUpperCase()}
              </Text>
              <Text
                fontFamily={"DINPro"}
                mt={"9px"}
                fontSize="12px"
                color="#767473"
              >
                {content.component === "blog" || "blog_card" ? "BLOG" : "PLANT"}
              </Text>
              {size === 1 && (
                <Text
                  display={["none", "block"]}
                  maxHeight={"75px"}
                  color="#767473"
                  fontSize={"16px"}
                  lineHeight="25px"
                >
                  {content?.blog?.content?.summary}
                </Text>
              )}
            </Box>
          </Box>
        </Link>
        <Box display={["block", "none"]}>
          {content.isSmallCard && <BlogCard displayDate {...content.blog} />}
        </Box>
      </>
    );
  return null;
};
